/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are syllables counted?`)
};

const es_syl_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se cuentan las sílabas?`)
};

const de_syl_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie werden Silben gezählt?`)
};

const nl_syl_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe worden lettergrepen geteld?`)
};

const fr_syl_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment les syllabes sont-elles comptées ?`)
};

const it_syl_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come vengono contate le sillabe?`)
};

const pt_br2_syl_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como as sílabas são contadas?`)
};

const pt_syl_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como são contadas as sílabas?`)
};

const ja_syl_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音節はどのようにカウントされますか？`)
};

const zh_syl_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音节是如何统计的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_hub_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_hub_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_hub_faq1_q", locale)
	if (locale === "en") return en_syl_hub_faq1_q(inputs)
	if (locale === "es") return es_syl_hub_faq1_q(inputs)
	if (locale === "de") return de_syl_hub_faq1_q(inputs)
	if (locale === "nl") return nl_syl_hub_faq1_q(inputs)
	if (locale === "fr") return fr_syl_hub_faq1_q(inputs)
	if (locale === "it") return it_syl_hub_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_syl_hub_faq1_q(inputs)
	if (locale === "pt") return pt_syl_hub_faq1_q(inputs)
	if (locale === "ja") return ja_syl_hub_faq1_q(inputs)
	return zh_syl_hub_faq1_q(inputs)
};